import { getValue } from "../../../common/getValue";
import moment from 'moment';

export function LOYALTY_PURCHASE_REQUEST(state) {
  state;
  state.loyaltyPurchases = {
    ...state.loyaltyPurchases,
    isLoading: true
  };
}
export function LOYALTY_PURCHASE_SUCCESS(state, payload) {
  const data = [];

  payload.data.purchaseHistories.rows.sort(function compare(b, a) {
    var dateA = new Date(a.updatedAt);
    var dateB = new Date(b.updatedAt);
    return dateA - dateB;
  });

  payload.data.purchaseHistories.rows.map((item, idx) => {
    data.push({
      idx: idx,
      id: item._id || "-",
      branch: getValue(item, 'buyerBranch', "-"),
      orderId: getValue(item, '_id', "-"),
      customerName: getValue(item, 'buyerName', "-"),
      itemName: getValue(item, 'loyaltyItem.name', "-"),
      point: getValue(item, 'loyaltyTransaction.rewardAmount', "-"),
      status: getValue(item, 'status', "-"),
      dateTime: moment(getValue(item, 'updatedAt', "-")).format('DD-MM-YYYY HH:mm:ss'),
      balancePoint: getValue(item, 'balancePoint', "0"),
    });
    return item;
  });
  state;
  state.loyaltyPurchases = {
    data: data,
    count: payload.data.purchaseHistories.count,
    status: payload.status,
    isLoading: false
  };
}
export function LOYALTY_PURCHASE_ERROR(state, payload) {
  state;
  state.loyaltyPurchases = {
    ...state.loyaltyPurchases,
    isLoading : false,
    error : true,
    errorMessage : payload,
  }
}
